<ng-container *ngIf="!isLoading">
  <div>
    <div style="margin-left: 70%; margin-bottom: 2%">
      <!-- <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section" ngxPrint>
        print
      </button> -->
        <button class="noPrint"
        style="margin-right: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>
      <button class="noPrint" style="margin-top: 2% 2% 0 2%;" (click)="exportExcel('Prantwise_Subscription_Bussiness_Report')"
        mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div>
  </div>
  <div>
    <div class="container" id="print-section">
      <table class="table table-bordered">
        <thead>

          <tr>
            <th [attr.colspan]="totalth - 1" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="5" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

          <tr>
            <th [attr.colspan]="totalth - 1" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण व्यवसाय तपशील - प्रांतनूसार
               <span *ngIf="appliedFilters">
                    <small>
                        <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;"> |<strong>देश:</strong>  <strong>{{ appliedFilters.country }}</strong> </span>
                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;"> | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong> </span>
                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;"> |<strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong> </span>
                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;"> | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong> </span>
                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;"> |<strong>वर्गणी प्रकार:</strong> <strong> {{ appliedFilters.subscriptionType }}</strong></span>
                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;"> | <strong>प्रतिनिधी: </strong> <strong>{{ appliedFilters.rep }}</strong></span>
                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;"> |<strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong> </span>
                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;"> | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong> </span>
                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;"> | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong> </span>

                    </small>
                </span>
            </th>

            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startdate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="2" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ enddate | date:'dd-MM-yyyy' }}
            </th>
          </tr>


          <tr>
            <th colspan="3"
              style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">प्रांत
            </th>
            <!-- <th rowspan="1"
              style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{countryNameNew}} &nbsp;&nbsp;</th>
            <th rowspan="1"
              style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
              {{stateNameNew}}</th> -->
            <th colspan="4"
              style="border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">एकूण
            </th>
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" colspan="4"
                style="text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
                {{ data.name }}</th>
            </ng-container>
          </tr>
          <tr>
            <!-- <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">देश</th>
            <th style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">राज्य</th> -->
            <th colspan="3" style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">जिल्हा</th>
            <th
              style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">
              वर्गणीदार संख्या</th>
            <th style="border-bottom: 2px solid black; border-left: 2px solid black; word-wrap: break-word;">रक्कम</th>
            <th style="border-bottom: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="border-bottom: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <!-- <th style="border-bottom: 2px solid black; word-wrap: break-word;">नूतनी-बाकी</th> -->
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible"
                style="border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">नवीन</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; word-wrap: break-word;">एकूण</th>
              <th *ngIf="data.isVisible" style="border-bottom: 2px solid black; word-wrap: break-word; border-right: 2px solid black;">रक्कम</th>
              <!-- <th *ngIf="data.isVisible"
                style="border-right: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">नूतनी-बाकी
              </th> -->
              
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <!-- <ng-container *ngFor="let data of finalData; let end=last;">
              <tr *ngIf="!end">
                <td>{{ data['country']}}</td>
                <td>{{ data['state']}}</td>
                <td>{{ data['district']}}</td>
                <td>{{ data['एकूण'] }}</td>
                <td>{{ data['नवीन'] }}</td>
                <td>{{ data['नूतनीकरण'] }}</td>
                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td>{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                    <td>{{ data[getKey(sub.name)+ '_नूतनीकरण'] }}</td>
                    <td>{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                  </ng-container>
                </ng-container>
              </tr>
              <tr class="smallHeading" *ngIf="end">
                <td colspan="3">{{ data['name'] }}</td>
                <td>{{ data['एकूण'] }}</td>
                <td>{{ data['नवीन'] }}</td>
                <td>{{ data['नूतनीकरण'] }}</td>
                <ng-container *ngFor="let sub of subTypesName">
                  <ng-container *ngIf="sub.isVisible">
                    <td>{{ data[getKey(sub.name)+ '_नवीन'] }}</td>
                    <td>{{ data[getKey(sub.name)+ '_नूतनीकरण'] }}</td>
                    <td>{{ data[getKey(sub.name)+ '_एकूण'] }}</td>
                  </ng-container>
                </ng-container>
              </tr>
            </ng-container> -->


<ng-container *ngFor="let data of finalData; let i = index; let end = last">

  <!-- Prant Heading Row -->
  <tr *ngIf="data.isDistrictTotal && data.prant_name && (i === 0 || data.prant_name !== finalData[i-1]?.prant_name)">
    <td colspan="3" class="smallHeading"
        style="font-weight: bold; text-align: center; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; background-color: #9c9393;">
      {{ data.prant_name }}
    </td>
    <ng-container *ngFor="let s of subTypesName">
      <td *ngIf="s.isVisible" colspan="4" style="border-right: 2px solid black; border-bottom: 2px solid black;"></td>
    </ng-container>
    <td colspan="4" style="border-right: 2px solid black; border-bottom: 2px solid black;"></td>
  </tr>

  <!-- District / City Row -->
  <tr *ngIf="data.isDistrictTotal && data.district_name">
    <td colspan="3" style="text-align: center; border-right: 2px solid black; border-left: 2px solid black;">
      {{ data['district_name'] }} <!-- automatically shows city if district missing -->
    </td>
    <td style="text-align: right;">{{ data['वर्गणीदार संख्या'] }}</td>
    <td style="text-align: right;">{{ data['रक्कम'] }}</td>
    <td style="text-align: right;">{{ data['नवीन'] }}</td>
    <td style="text-align: right; border-right: 2px solid black;">{{ data['नूतनीकरण'] }}</td>
    <!-- <td style="text-align: right; border-right: 2px solid black;">{{ data['नूतनी-बाकी'] }}</td> -->

    <!-- Subscription Type Totals -->
    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="text-align: right;">{{ data[getKey(sub.name) + '_नवीन'] }}</td>
        <td style="text-align: right;">{{ data[getKey(sub.name) + '_नूतनीकरण'] }}</td>
        <td style="text-align: right;">{{ data[getKey(sub.name) + '_एकूण'] }}</td>
        <td style="text-align: right; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_रक्कम'] }}</td>
        <!-- <td style="text-align: right; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_नूतनी-बाकी'] }}</td> -->
      </ng-container>
    </ng-container>
  </tr>

  <!-- Prant Total Row -->
  <tr class="smallHeading" *ngIf="data.isPrantTotal && data.prant_name">
    <td colspan="3" style="text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black;">
      {{ data.prant_name }} - एकूण :-
    </td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['वर्गणीदार संख्या'] }}</td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['रक्कम'] }}</td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['नवीन'] }}</td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data['नूतनीकरण'] }}</td>
    <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data['नूतनी-बाकी'] }}</td> -->

    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name) + '_नवीन'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name) + '_नूतनीकरण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name) + '_एकूण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_रक्कम'] }}</td>
        <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_नूतनी-बाकी'] }}</td> -->
      </ng-container>
    </ng-container>
  </tr>

  <!-- Grand Total Row -->
  <tr class="smallHeading" *ngIf="end && data.name">
    <td colspan="3" style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">
      {{ data['name'] }}
    </td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['वर्गणीदार संख्या'] }}</td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['रक्कम'] }}</td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data['नवीन'] }}</td>
    <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data['नूतनीकरण'] }}</td>
    <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data['नूतनी-बाकी'] }}</td> -->

    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name) + '_नवीन'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name) + '_नूतनीकरण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black;">{{ data[getKey(sub.name) + '_एकूण'] }}</td>
        <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_रक्कम'] }}</td>
        <!-- <td style="text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black;">{{ data[getKey(sub.name) + '_नूतनी-बाकी'] }}</td> -->
      </ng-container>
    </ng-container>
  </tr>

</ng-container>







        </tbody>
      </table>
    </div>
  </div>

</ng-container>
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>